import { Rating } from '../../Rating';

import * as S from './styles';

export function ProductRatingItem({ item }) {
  return (
    <S.Container className="product-rating-item">
      <div>
        <span>{item.nome}</span>
        <span>{new Date(item.criadoEm).toLocaleDateString()}</span>
      </div>

      <Rating nota={item.nota} />

      <span>{item.comentario}</span>
    </S.Container>
  );
}
